export const DISCIPLINES = {
  BEACH_SOCCER: 27,
  FOOTBALL: 25,
  INTERACTIVE: 28,
  MASS_FOOTBALL: 29,
  MINI_FOOTBALL: 26,
};
